import { useEffect, useRef, useState } from 'react'

import { useRouter } from 'next/router'

import classNames from 'classnames'

import Text, { TextSizes } from '~/components/atoms/Text/Text'
import { useInPageNavContext } from '~/contexts/InPageNavContext'
import { useMediaQuery } from '~/services/useMediaQuery'
import bp from '~/styles/breakpoints/breakpoints'

import Container, { gutterTypes } from '../Container/Container'
import Link from '../Link/Link'

import styles from './PageSubMenu.module.css'

export interface PageSubMenuProps {
  pageLinks?: {
    label: string
    path?: string
    onClickHandler?: () => void
    isActive?: boolean
  }[]
  articleArtists?: any
  testID?: string
  noBorder?: boolean
  testAttr?: string
}

export default function PageSubMenu({
  pageLinks,
  testID,
  noBorder = false,
  testAttr = 'page-submenu',
}: PageSubMenuProps) {
  const isMobile = useMediaQuery(`(max-width: ${bp.bpLarge})`)

  const [isElementTouchingTop, setIsElementTouchingTop] =
    useState<boolean>(false)

  const { mainHeaderVisible } = useInPageNavContext()

  const router = useRouter()
  const path = router.asPath

  const filtersRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleScroll = () => {
      const element = filtersRef.current
      if (element) {
        const elementRect = element.getBoundingClientRect()
        const topValue = mainHeaderVisible ? 54 : 0
        const isTouchingTop = elementRect.top <= topValue
        setTimeout(() => {
          setIsElementTouchingTop(isTouchingTop)
        }, 10)
      }
    }

    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <>
      <div
        className={classNames(styles.base, {
          [styles.stuck]: isElementTouchingTop,
          // [styles.mergeNav]: mainHeaderVisible,
          [styles.noBorder]: noBorder,
        })}
        data-testid={testID}
        ref={filtersRef}
        data-test={testAttr}
      >
        {isElementTouchingTop}
        <Container gutters={gutterTypes.always} cssClass={styles.container}>
          <div className={classNames(styles.inner)}>
            <div className={classNames(styles.scroller)}>
              <div className={classNames(styles.articleFilters)}>
                <div className={styles.menuContainer}>
                  {pageLinks?.map((link: any, index: number) => {
                    return (
                      <div>
                        <Link
                          key={index}
                          href={link?.path || '#'}
                          onClick={e => {
                            if (link?.onClickHandler) {
                              e.preventDefault()
                              link?.onClickHandler()
                            }
                          }}
                          className={classNames(styles.dropdownMenuItem, {
                            [styles.active]:
                              path === link?.path || link?.isActive,
                          })}
                          data-test={`page-submenu-link-${link.path}`}
                        >
                          <Text size={TextSizes.primaryTitleXSml}>
                            {link.label}
                          </Text>
                        </Link>
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
          </div>
        </Container>
      </div>
    </>
  )
}
